'use client'

import { type ComponentProps, Suspense } from 'react'

import dynamic from 'next/dynamic'

import type { FeaturedProducts } from '@/components/server/storyblok/article/featured-products'
import { FeaturedProductsHeader } from '@/components/server/storyblok/article/featured-products-header'
import { FeaturedProductSkeleton } from '@/components/server/storyblok/article/featured-products-skeleton'
import { SIDEBAR_PRODUCT_COUNT } from '@/lib/sidebar/constants'

const Products = dynamic(() =>
  import('@/components/server/storyblok/article/featured-products').then((module) => module.FeaturedProducts)
)

export const FeaturedProductsLazy = (props: ComponentProps<typeof FeaturedProducts>) => {
  const visibleCount = Math.min(props.products.length, SIDEBAR_PRODUCT_COUNT)
  if (!visibleCount) {
    return null
  }

  return (
    <Suspense
      fallback={
        <div className="flex flex-col gap-5">
          <FeaturedProductsHeader
            title={props.labels.featuredProducts}
            compareAll={props.labels.compareAll}
            className={props.headerClassName}
          />
          <FeaturedProductSkeleton variant="featured" />
          {visibleCount > 1 && (
            <div className="flex flex-col gap-4">
              {Array.from({ length: visibleCount - 1 }, (_, index) => (
                <FeaturedProductSkeleton key={index} variant="list" />
              ))}
            </div>
          )}
        </div>
      }
    >
      <Products {...props} />
    </Suspense>
  )
}
